<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="payslipsenders">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="massiveSend" >
            <feather-icon icon="SendIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-error">Massive Send</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ payslipsenders.length -
              currentPage
              * itemsPerPage > 0 ? currentPage * itemsPerPage : payslipsenders.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="category">Name</vs-th>
        <vs-th sort-key="name">SAGA EMPLOYEE Code</vs-th>
        <vs-th sort-key="name">Phone No</vs-th>
        <vs-th sort-key="contract">Generated File</vs-th>
        <vs-th sort-key="start">Sms sent?</vs-th>
        <vs-th sort-key="stop">When Sms?</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="font-medium truncate">{{ tr.employeename }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.employeecode }}</p>
            </vs-td>
            <vs-td>
              <p v-if="tr.phone">{{ tr.phone }}</p>
              <p v-else>No phone or Employee code</p>
            </vs-td>
            <vs-td>
              <p @click="downloadPayslip(tr)">{{ tr.generated_filename }}</p>
            </vs-td>
            <vs-td>
              <vs-chip :color="getActiveColors(tr.issmssent)" v-if="tr.issmssent">Already Sent</vs-chip>
              <vs-chip :color="getActiveColors(tr.issmssent)" v-else>To be sent</vs-chip>
            </vs-td>
            <vs-td>
              <p v-if="tr.whensmssent">{{ tr.whensmssent }}</p>
              <p v-else>Never</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <!-- Envoi SMS supprimé : les fiches de paie sont désormais poussées
                   automatiquement dans l'application de pointage à l'import du XLS. -->
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import moduleDataListPayslip from '@/store/payslip/moduleDataList.js'
import axios from "@/axios.js";

export default {
  components: {
    DataViewSidebar
  },
  data() {
    return {
      displayinactive: false,
      isadmin: false,
      selected: [],
      itemsPerPage: 1000,
      isMounted: false,
      buttonName: 'Display Inactive',
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    payslipsenders() {
      return this.$store.state.dataListPayslip.payslipsender
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.payslipsenders.length
    }
  },
  methods: {
    massiveSend() {
      this.$vs.notify({
        title: "Coming soon...",
        iconPack: "feather",
        icon: "icon-message-circle",
        color: "danger",
        position: "bottom-right",
        time: 3000,
      });
/*
      const smsList = this.payslipsenders
        .filter(tr => tr.phone && !tr.issmssent)
        .slice(0, 2); // limit to 3

      if (smsList.length === 0) {
        this.$vs.notify({
          title: "Notice",
          text: "No valid recipients found.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "bottom-right",
          time: 5000,
        });
        return;
      }

      smsList.forEach(tr => {
        const smsText = `${tr.employeename}, payslip: https://bit.ly/xylo-fluturas (CODE: ${tr.idpayslipsenders}${tr.employeename.slice(0, 2).toLowerCase()}${tr.phone.slice(-2).toLowerCase()})`;

        axios.post('/clicksend/createsms', {
          to: tr.phone.replace(/\s+/g, ''),
          smscontent: smsText,
          payslipsenderid: tr.idpayslipsenders
        }).then(() => {
          tr.issmssent = true;
        }).catch(err => {
          console.error(`Error sending to ${tr.phone}`, err);
        });
      });

      this.$vs.notify({
        title: "Success",
        text: `${smsList.length} test message(s) sent.`,
        iconPack: "feather",
        icon: "icon-check",
        color: "success",
        position: "bottom-right",
        time: 8000,
      });*/
    },
    downloadPayslip(tr) {
      const filename = tr.generated_filename;

      axios({
        url: `/clicksend/download/${filename}`, // Construire l'URL avec le nom de fichier
        method: 'GET',
        responseType: 'blob' // Indiquer que la réponse est un blob (fichier binaire)
      })
        .then((response) => {
          // Créer un lien temporaire pour télécharger le fichier
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename); // Nom du fichier téléchargé
          document.body.appendChild(link);
          link.click();

          // Nettoyage
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('Error downloading the file:', error);
          alert('Erreur lors du téléchargement du fichier.');
        });
    },
    displayInactiveEmployee() {
      if (this.buttonName.includes("Display Inactive")) {
        this.buttonName = 'Display Only Active'
        this.displayinactive = true;
      }
      else {
        this.buttonName = 'Display Inactive'
        this.displayinactive = false;
      }
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    editData(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getActiveColors(status) {
      if (status) return 'primary'
      else return 'danger'
      return 'black'
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    }
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin") || localStorage.getItem("login-roles").toLowerCase().includes("moderator")) {
      this.isadmin = true
      if (!moduleDataListPayslip.isRegistered) {
        this.$store.registerModule('dataListPayslip', moduleDataListPayslip)
        moduleDataListPayslip.isRegistered = true
      }
      const idpayslip = this.$route.params.id
      this.$store.dispatch('dataListPayslip/fetchPayslipSender', idpayslip)
    }
    else {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });

    }
  },
  mounted() {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
